// @flow
import axios from "axios";
import { BASE_URL_API } from "../store";
import modelAuction from "../models/auction";

import type { AuctionsApiItem } from "../models/auction";

export type AuctionsApiData = Array<AuctionsApiItem>;

export const auctions = (locale: string) => async () => {
  const response = await axios.get(`${BASE_URL_API}/v1/auctions`, {
    params: { locale: locale }
  });
  if (response.statusText === "OK") {
    let data = (response.data: AuctionsApiData);
    let returnable = {};
    (data || []).map(modelAuction).forEach(item => {
      returnable[item.id] = item;
    });
    return returnable;
  } else {
    throw response.status;
  }
};

export type AuctionApiData = AuctionsApiItem;

export const auction = (id: number, locale: string) => async () => {
  const response = await axios.get(`${BASE_URL_API}/v1/auction/${id}`, {
    params: { locale: locale }
  });
  if (response.statusText === "OK") {
    let data = (response.data: AuctionApiData);

    return { [id]: modelAuction(data) };
  } else {
    throw response.status;
  }
};



// WEBPACK FOOTER //
// ./src/redux/api/auctions.js